
import axios from "axios";
import { defineComponent } from "vue";
import { isAthleteMinor } from "@/utils/mixins/athlete";

export default defineComponent({
  data() {
    return {
      birthDate: "",
    };
  },
  methods: {
    isAthleteMinor,
    getBirthDate() {
      this.birthDate = this.$store.getters["user/getMe"].dateOfBirth;
    },
    closeModal() {
      this.$emit("closeCertificateModal");
    },
    async uploadCertificate() {
      let formData = new FormData();
      let imageFile: HTMLInputElement | null =
        document.querySelector("#inputCertificate");
      if (imageFile && imageFile.files && imageFile.files[0]) {
        formData.append("certificate", imageFile.files[0]);
        formData.append(
          "editionId",
          this.$store.getters["edition/getEditionId"]
        );
        const response = await axios.post("/certificates/upload", formData);
        if (response.status !== 200) return this.$emit("openErrorModal");
        this.closeModal();
        this.$store.dispatch("user/setMe");
      }
    },
  },
  beforeMount() {
    this.getBirthDate();
  },
});
